import { Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ContextService, Roles } from 'ngx-orgkit';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'ws-settings-view',
  templateUrl: './settings-view.component.html',
  styleUrls: ['./settings-view.component.scss']
})
export class SettingsViewComponent implements OnInit {

  @Input()
  location = 'organization';

  // TODO: Resolve this directly from the routes?
  menuItems: {id: string, label: string}[] = [
    {id: 'organization', label: $localize`Company Details`},
    {id: 'people', label: $localize`People`},
    {id: 'accounting', label: $localize`Accounting`},
    {id: 'customer-notifications', label: $localize`Customer Notifications`},
    {id: 'subscription', label: $localize`Subscription`},
    {id: 'planning', label: $localize`Planning`},
    {id: 'api-keys', label: $localize`Api Keys`}
  ];

  constructor(public router: Router, private context: ContextService) { 
    router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(e => {
        const url = (e as NavigationEnd).urlAfterRedirects;
        this.location = url.substring(1);
    });
  }

  ngOnInit(): void {
  }

  get hasOrganization() {
    return this.context.organizationId != null;
  }

  get isManager() {
    const roles = this.context.account.roles;
    const permissions = Roles.getPermissionsForOrganization(roles, this.context.organizationId!);
    return roles.includes(Roles.ADMIN_ROLE) || permissions.filter(p => ['ADMIN', 'MANAGEMENT'].includes(p))?.length > 0;
  }

  get name() {
    return this.context.account?.name;
  }

  get email() {
    return this.context.account?.email;
  }

  get initials() {
    if (this.context?.account) {
      const name = this.context?.account.name;
      const names = name.split(' ');
      return names[0].charAt(0).toLocaleUpperCase() + (names.length > 1 ? names[names.length - 1].charAt(0).toLocaleUpperCase() : '');
    } else {
      return '?'
    }
  }

}
